<template>
  <div>
    <div class="divider divider--horizontal"></div>
    <div style="display: flex; flex-direction: row;">
      <span style="color: #5d9cec; flex: 0 0 auto; line-height: 32px;">{{
        orderStr
      }}</span>
      <div style="flex: 1 1 0%;">
        <div style="padding: 0 12px;">
          <div style="font-size: 16px; line-height: 32px;">{{ title }}</div>
        </div>
        <div style="padding: 12px;">
          <div style="font-size: 14px; color: grey;">{{ description }}</div>
        </div>
        <gallery-mobile :pictures="pictures" />
        <div v-if="type === 1">
          <van-field readonly :value="value" class="border-bottom" />
        </div>
        <div v-else-if="type === 2">
          <van-field
            :value="value"
            readonly
            type="textarea"
            rows="1"
            autosize
            class="border-bottom"
          />
        </div>
        <template v-else-if="type === 3">
          <radio-group
            :value="value"
            :options="options"
            :labelFormat="labelFormat"
            readonly
          ></radio-group>
          <van-field v-if="showRemark" :value="extra" class="border-bottom" />
        </template>
        <checkbox-group
          v-else-if="type === 4"
          :value="value"
          :options="options"
          :labelFormat="labelFormat"
          readonly
        ></checkbox-group>
        <div v-else-if="type === 5">
          <dropdown-menu
            :value="value"
            :options="options"
            :labelFormat="labelFormat"
            readonly
          ></dropdown-menu>
          <van-field v-if="showRemark" :value="extra" class="border-bottom" />
        </div>
        <date-picker
          v-else-if="type === 6"
          v-model="currentValue"
          readonly
        ></date-picker>
        <area-single-selector-mobile
          v-else-if="type === 7"
          :value="areaValueProxy"
          readonly
        ></area-single-selector-mobile>
        <gallery-mobile v-else-if="type === 8" :pictures="imagesProxy" />
        <div v-else-if="type === 9">{{ value }}</div>
        <div v-else-if="type === 10">{{ addressProxy }}</div>
        <div v-else>如果看到了这行文字，说明程序出bug了</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Field } from "vant";
import DatePicker from "@/components/mobile/DatePicker";
import DropdownMenu from "@/components/mobile/DropdownMenu";
import CheckboxGroup from "@/components/mobile/CheckboxGroup";
import RadioGroup from "@/components/mobile/RadioGroup";
import GalleryMobile from "@/components/common/GalleryMobile";
import { labelFormat } from "@/utils/SchemaHelper";
import AreaSingleSelectorMobile from "@/components/common/AreaSingleSelectorMobile";
export default {
  name: "answer-read-only-item-mobile",
  components: {
    AreaSingleSelectorMobile,
    GalleryMobile,
    [Field.name]: Field,
    DatePicker,
    DropdownMenu,
    CheckboxGroup,
    RadioGroup,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    extra: {
      type: String,
    },
    type: {
      type: Number,
      required: true,
    },
    pictures: {
      type: Array,
    },
    order: {
      type: Number,
      required: true,
    },
    schema: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      labelFormat,
    };
  },
  computed: {
    showRemark() {
      const { schema } = this.$props;
      if (schema) {
        const { options } = schema;
        const currentValue = `${this.value}`;
        if (
          options.length &&
          options.some(
            (it) => it.allowedRemark && `${it.order}` === currentValue
          )
        ) {
          return true;
        }
      }
      return false;
    },
    currentValue: {
      get() {
        return this.$props.value;
      },
      set(value) {
        this.$emit("change", value);
      },
    },
    areaValueProxy() {
      return this.$props.value
        .split(",")
        .map((it) => Number.parseInt(it))
        .filter((it) => !isNaN(it));
    },
    orderStr() {
      return `${this.$props.order}`.padStart(2, "0");
    },
    options() {
      return (this.$props.schema && this.$props.schema.options) || [];
    },
    imagesProxy() {
      if (this.type !== 8) {
        return [];
      }
      if (this.value) {
        return JSON.parse(this.value) || [];
      }
      return [];
    },
    addressProxy() {
      if (this.type !== 10 || !this.value) {
        return "";
      }
      const obj = JSON.parse(this.value);
      if (obj) {
        return obj.address;
      }
      return "";
    },
  },
};
</script>
<style>
.border-bottom.van-cell.van-field {
  font-size: 18px;
  line-height: 24px;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border: none;
  border-bottom: 1px solid #c7c7c7;
  border-radius: unset;
}
.van-dropdown-menu__title {
  flex: 1 1 0%;
  margin: 5px;
}
</style>
